import { render, staticRenderFns } from "./events-detail.vue?vue&type=template&id=68f6aabf&"
import script from "./events-detail.vue?vue&type=script&lang=js&"
export * from "./events-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports